import React from 'react';
import { connect } from 'react-redux';
import Clients from '../../views/Clients';
import ClientManagement from '../../components/ClientManagement'
import { getOrganizations, updateCustomers } from './ClientsAction';
import { getInvitationCodes, generateInvitationCode, inviteClient } from './InvitationsActions';


class ClientManagementContainer extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let { clients, dispatchUpdateCustomers, dispatchGetInvitationCodes, dispatchInviteClient, dispatchGenerateInvitationCode, dispatchGetOrganizations } = this.props;

        return (
            <ClientManagement
                clients={clients}
                dispatchUpdateCustomers={dispatchUpdateCustomers}
                dispatchGetInvitationCodes={dispatchGetInvitationCodes}
                dispatchInviteClient={dispatchInviteClient}
                dispatchGenerateInvitationCode={dispatchGenerateInvitationCode}
                dispatchGetOrganizations={dispatchGetOrganizations}
            />
        )
    }

}

const mapStateToProps = (state) => ({
    clients: state.clients
});

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchUpdateCustomers: (parameters, cb) => dispatch(updateCustomers(parameters, cb)),
        dispatchInviteClient: (email, cb) => dispatch(inviteClient(email, cb)),
        dispatchGenerateInvitationCode: () => dispatch(generateInvitationCode()),
        dispatchGetOrganizations: () => dispatch(getOrganizations()),
        dispatchGetInvitationCodes: () => dispatch(getInvitationCodes())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientManagementContainer);


// WEBPACK FOOTER //
// ./src/containers/Clients/ClientManagementContainer.js